"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recoverStoreNestedPath = exports.resetStorePath = exports.hasStoreError = exports.setStoreValueErrors = exports.getStoreState = void 0;
const valueConfig_1 = require("./valueConfig");
const valuePath_1 = require("./valuePath");
const valueState_1 = require("./valueState");
const getStoreState = (store, path) => {
    let item = store.find(x => (0, valuePath_1.checkSamePath)(x.path, path));
    if (!item) {
        item = { path, state: {} };
        store.push(item);
    }
    return item.state;
};
exports.getStoreState = getStoreState;
/** Reset only value errors */
const resetStoreValueErrors = (store, path, dependent) => {
    store.forEach(item => {
        const isSubPath = (0, valuePath_1.checkSubPath)(item.path, path);
        const isBasePath = (0, valuePath_1.checkSubPath)(path, item.path);
        const isDependent = dependent === null || dependent === void 0 ? void 0 : dependent.some(x => (0, valuePath_1.checkSamePath)(x, item.path));
        if (!isSubPath && !isBasePath && !isDependent)
            return;
        item.state.error = undefined;
    });
};
/** Set only value errors by schema */
const setStoreValueErrors = (store, path, issues, config, dependent) => {
    resetStoreValueErrors(store, path, dependent);
    issues.forEach(issue => {
        const issuePath = issue.path;
        const isSubPath = (0, valuePath_1.checkSubPath)(issuePath, path);
        const isBasePath = (0, valuePath_1.checkSubPath)(path, issuePath);
        const isDependent = dependent === null || dependent === void 0 ? void 0 : dependent.some(x => (0, valuePath_1.checkSamePath)(x, issuePath));
        if (!isSubPath && !isBasePath && !isDependent)
            return;
        const state = (0, exports.getStoreState)(store, issuePath);
        const pathConfig = (0, valueConfig_1.getPathValueConfig)(config, issuePath);
        const message = (pathConfig === null || pathConfig === void 0 ? void 0 : pathConfig.skipValidation) ? undefined : issue === null || issue === void 0 ? void 0 : issue.message;
        state.error = message;
    });
};
exports.setStoreValueErrors = setStoreValueErrors;
const hasStoreError = (store) => {
    const withError = store.find(x => x.state.nativeError || x.state.error);
    return !!withError;
};
exports.hasStoreError = hasStoreError;
/**
 * Reset subpath on change value by path.
 * All internal states are invalid by design after changing value.
 * */
const resetStorePath = (store, path, isResetRoot) => {
    store.forEach(item => {
        const isSubPath = (0, valuePath_1.checkSubPath)(item.path, path);
        const isRoot = (0, valuePath_1.checkSamePath)(item.path, path);
        if (isSubPath && (!isRoot || isResetRoot)) {
            Object.keys(item.state).forEach(key => {
                delete item.state[key];
            });
        }
    });
};
exports.resetStorePath = resetStorePath;
/** Need to recover states for memo after rough nested cleaning */
const recoverStoreNestedPath = (store, path, value) => {
    store.forEach(item => {
        const isSubPath = (0, valuePath_1.checkSubPath)(item.path, path);
        const isRoot = (0, valuePath_1.checkSamePath)(item.path, path);
        if (isSubPath && !isRoot) {
            const pathValue = (0, valuePath_1.getPathValue)(value, item.path);
            (0, valueState_1.recoverStateOnChangeNestedValue)(item.state, pathValue);
        }
    });
};
exports.recoverStoreNestedPath = recoverStoreNestedPath;
//# sourceMappingURL=valueStore.js.map